export default "/_next/static/chunks/fonts/AbrilFatface-Regular-latin-0cf3b0213c405bf58232f794258d9a61.woff2";